import { Heading_default } from "./chunk-JL63HSDD.js";
import { Link_default } from "./chunk-WLZ2VL3G.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Dialog/Dialog.Header.tsx
import { useCallback } from "react";
import { Dialog as HeadlessDialog } from "@headlessui/react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var DialogHeader = _a => {
  var _b = _a,
    {
      children,
      onClose,
      title,
      variant = "display",
      dismissLabel,
      className
    } = _b,
    rest = __objRest(_b, ["children", "onClose", "title", "variant", "dismissLabel", "className"]);
  const handleClose = useCallback(() => onClose(false), [onClose]);
  return /* @__PURE__ */jsxs("header", __spreadProps(__spreadValues({
    className: clsx("pd-dialog__header", className)
  }, rest), {
    children: [/* @__PURE__ */jsxs("div", {
      className: "pd-dialog__title",
      children: [/* @__PURE__ */jsx(Heading_default, {
        variant,
        size: "2",
        as: HeadlessDialog.Title,
        children: title
      }), /* @__PURE__ */jsx(Link_default, {
        as: "button",
        type: "button",
        className: "pd-dialog__close",
        variant: "secondary",
        onClick: handleClose,
        screenReaderLabel: dismissLabel,
        iconBefore: "times"
      })]
    }), children]
  }));
};
var Dialog_Header_default = DialogHeader;
export { Dialog_Header_default };